  import React, { useEffect } from "react";
import "./Home.css";
import  washing from "../images/washing.webp";
import fridge from "../images/fridge.webp";
import oven from "../images/microwave.webp";
import ac from "../images/ac service.webp";
import wh from "../images/wh.webp";
import wp from "../images/wp.webp";
import tv from "../images/tv.webp";
import homeap from "../images/Home-Appliance-Repair-Services.webp"
import customer1 from "../images/cutomer1.webp"
function Home() {
    useEffect(() => {

    document.title =
      "Embarque Services - Doorstep Repair Service";

  }, []);
  return (
    <>
    <div className="home">

      {/* Hero Section */}

      <section className="home-hero">

        {/* Left Appliances */}


        {/* Content */}

        <div className="home-content">

          <h1>
            Home Appliance <br />
            Repairing <br />
            Service in Your <br />
            Doorsteps
          </h1>

        </div>

        {/* Form */}

        <div className="booking-form">

          <h2>
            +91 93639 29984
          </h2>

          <p>
            CALL US TODAY
          </p>

          <span>
            Register your home appliance complaints
          </span>

          <input
            type="text"
            placeholder="Name"
          />

          <input
            type="text"
            placeholder="Phone Number"
          />

          <input
            type="text"
            placeholder="Location"
          />

          <textarea
            placeholder="Describe the issue..."
          ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

          <button>
            SUBMIT
          </button>

        </div>

      </section>

    </div>


    
    {/* About Section */}

<section className="about-section">

  {/* Left Content */}

  <div className="about-left">

    <h1>
      A Team of Full-Service <br />
      Reliable Repairing <br />
      Professionals for <br />
      Home and Office <br />
      Needs
    </h1>

    <div className="about-box">

      <p>
        With 8+ years of experience in repairing services and supplies,
        our team of experts are here to help you with all your repairing needs.
      </p>

      <p>
        Whether it is a complicated issue or one that just needs a quick fix,
        we'll help you figure it out and fix it at the most affordable cost.
      </p>

    </div>

  </div>

  {/* Right Counter */}

  <div className="about-right">

    <h4>
      LET’S NUMBERS TALK
    </h4>

    <div className="counter-grid">

      <div className="counter-box">
        <h1>8+</h1>
        <p>Years in Business</p>
      </div>

      <div className="counter-box">
        <h1>40000+</h1>
        <p>Happy Customers</p>
      </div>

      <div className="counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="counter-box">
        <h1>20+</h1>
        <p>Multiple Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>


{/* Services Section */}

<section className="services-section">

  <h1 className="service-title">
    Our Services
  </h1>

  <div className="services-grid">

    {/* Card 1 */}

    <div className="service-card">

      <img
        src={washing}
        alt="washing machine"
      />

      <h2>Washing Machine</h2>

      <p>
        Whether it's fixing a washing machine that won't spin or resolving
        a drainage issue, our technicians know what's best.
      </p>

    </div>

    {/* Card 2 */}

    <div className="service-card">

      <img
        src={fridge}
        alt="refrigerator"
      />

      <h2>Refrigerator</h2>

      <p>
        Emergency fridge repair or refrigerator installation support
        from experienced technicians.
      </p>

    </div>

    {/* Card 3 */}

    <div className="service-card">

      <img
        src={ac}
        alt="ac"
      />

      <h2>AC</h2>

      <p>
        Professional AC repair and maintenance services for homes
        and offices.
      </p>

    </div>

    {/* Card 4 */}

    <div className="service-card">

      <img
        src={tv}  
        alt="tv"
      />

      <h2>TV</h2>

      <p>
        Display issues, sound problems and motherboard repair
        solutions for all TV brands.
      </p>

    </div>
    <div className="service-card">

  <img
    src={oven}
    alt="microwave oven"
  />

  <h2>
    Microwave Oven
  </h2>

  <p>
    Fast and professional microwave oven repair solutions
    for heating issues, power failure, and maintenance support.
  </p>

</div>

    {/* Card 5 */}

    <div className="service-card">

      <img
        src={wh}
        alt="water heater"
      />

      <h2>Water Heater</h2>

      <p>
        Fast and reliable water heater repair and installation
        support at your doorstep.
      </p>

    </div>

    {/* Card 6 */}

    <div className="service-card">

      <img
        src={wp}
         alt="water purifier"
      />

      <h2>Water Purifier</h2>

      <p>
        Complete RO water purifier maintenance and filter replacement
        services.
      </p>

    </div>

  </div>

</section>


{/* WHY CHOOSE US */}

<section className="choose-section">

  <div className="choose-overlay">

    <h4>
      WHY CHOOSE US
    </h4>

    <h1>
      What Sets Us Apart
    </h1>

    <div className="choose-grid">

      <div className="choose-box">
        <div className="choose-icon">🕒</div>
        <h2>Perfection Anytime</h2>
      </div>

      <div className="choose-box">
        <div className="choose-icon">💬</div>
        <h2>Quick Service & Support</h2>
      </div>

      <div className="choose-box">
        <div className="choose-icon">💵</div>
        <h2>Affordable Cost</h2>
      </div>

      <div className="choose-box">
        <div className="choose-icon">🧯</div>
        <h2>Emergency Support</h2>
      </div>

      <div className="choose-box">
        <div className="choose-icon">🏠</div>
        <h2>Advanced Technology</h2>
      </div>

      <div className="choose-box">
        <div className="choose-icon">👨‍🔧</div>
        <h2> Experienced Technicians </h2>
      </div>

    </div>

  </div>

</section>


{/* REQUEST INFO SECTION */}

<section className="request-section">

  {/* Left Content */}

  <div className="request-left">

    <h1>
      Request Info
    </h1>

    <h2>
      Let It Be Any Appliances Work, <br />
      We Are Here to Help!!
    </h2>

  <p>
  We provide complete home appliance repair solutions with fast and
  professional doorstep service. Our  Experienced Technicians  specialize in
  washing machine repair, AC service, refrigerator repair, microwave oven
  repair, TV service, water heater repair, and water purifier maintenance.
  With over 8+ years of experience, we deliver reliable, affordable, and
  high-quality repair support for all major appliance brands.
</p>
  </div>

  {/* Right Image */}

  <div className="request-right">

    <img
      src={homeap}
      alt="home appliances"
    />

  </div>

</section>

{/* CUSTOMER SUPPORT SECTION */}

{/* <section className="support-section">

  

  <div className="support-image">

    <img
      src={customer1}    
        alt="customer support"
    />

  </div>

  

  <div className="support-content">

    <h2>
      Customer Support
    </h2>


    <div className="support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="support-box">
      <span>+</span>
      <p>Fast Doorstep Technician Service</p>
    </div>

    <div className="support-box">
      <span>+</span>
      <p>Professional Multi-Brand Repair Support</p>
    </div>

    <div className="support-box">
      <span>+</span>
      <p>Trusted & Experienced Service Team</p>
    </div>

    <div className="support-box">
      <span>+</span>
      <p>Affordable Service Charges</p>
    </div>

  </div>

</section> */}


<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>

<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>



    </>
  );
}

export default Home;